import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisible } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";


interface GrupoModuloState {
    status: string;
    error: string;
    grupoModuloList: any[],
    grupoModulo: {
        idGrupo: number | null;
        idGrupoModulo: number | null;
        idUsuario: string | null;
        primerNombre: string | null;
        primerApellido: string | null;
        nombre: string | null;
        fileImage: string | null;
        estadoCiclo: boolean | null;
        estadoModulo: boolean | null;
        sesionesEncargadoList: [],
        sesionesAlumnoList: [],
    }

}

const initialState: GrupoModuloState = {
    status: "",
    error: "",
    grupoModuloList: [],
    grupoModulo: {
        idGrupo: null,
        idGrupoModulo: null,
        idUsuario: null,
        primerNombre: null,
        primerApellido: null,
        nombre: null,
        fileImage: null,
        estadoCiclo: null,
        estadoModulo: null,
        sesionesEncargadoList: [],
        sesionesAlumnoList: []
    }
}

export const fetchGrupoModulo = createAsyncThunk('fetchGrupoModulo', async ({ idGrupo }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 110;
    const { result, message, data } = await getData({ idsp, idGrupo }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const modifyFacilitadorAsignado = createAsyncThunk('modifyFacilitadorAsignado', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const grupoModuloNew = selectGrupoModulo(state);
    const grupoModuloAttributes = { ...grupoModuloNew };
    const idGrupo = grupoModuloAttributes.idGrupo;
    const idsp = 108;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...grupoModuloAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchGrupoModulo({ idGrupo }));
    return rejectWithValue(message);
});

export const grupoModuloSlice = createSlice({
    name: 'grupoModulo',
    initialState,
    reducers: {
        setGrupoModuloList: (state, action) => {
            state.grupoModuloList = action.payload;
        },
        setGrupoModulo: (state, action) => {
            state.grupoModulo = !action.payload ? initialState.grupoModulo : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchGrupoModulo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchGrupoModulo.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.grupoModuloList = data ? data : [];

            })
            .addCase(fetchGrupoModulo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectGrupoModuloList = (state: RootState) => state.grupoModulo.grupoModuloList;
export const selectGrupoModulo = (state: RootState) => state.grupoModulo.grupoModulo;

export const { setGrupoModuloList, setGrupoModulo } = grupoModuloSlice.actions;

export default grupoModuloSlice.reducer;
